// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__WXjFD","spinner":"LoadingSpinner_spinner__SbEnr","spin":"LoadingSpinner_spin__sYK6Y"};